import React from "react";
import { toast } from "react-toastify";
//primereact
import { Accordion, AccordionTab } from "primereact/accordion";
//components
import CopyTextInput from "../../../../components/input/CopyTextInput";
import { getVariables } from "../../../../services/Contracts/getVariables";
import { useQuery } from "react-query";
import Modal from "../../../../components/modal/Modal";
import { Skeleton } from "primereact/skeleton";

const Variables = ({ type, visible, setVisible }) => {
  const { data: variables, isLoading } = useQuery({
    queryKey: [`variables_${type}`],
    queryFn: () => getVariables(type),
    retry: false,
    enabled: visible,
  });

  console.log(variables);
  return (
    <Modal
      dynamicTitle="Variáveis"
      visible={visible}
      style={{ width: "80vw" }}
      onHide={() => setVisible(false)}
    >
      {isLoading ? (
        <Skeleton width="100%" height="500px" />
      ) : (
        <>
          <div className="row">
            <div className="col-md-12">
              <div className="card p-3 bg-cyan-300 rounded-3 bg-opacity-75">
                <span className="text-blue-800">
                  <i className="fa-solid fa-circle-info me-1 "></i>
                  <b>Atenção</b> <br />
                  Clique na variável que deseja copiar, após copiar cole a
                  variável no seu contrato nos respectivos lugares que deseja{" "}
                  <b>autopreenchimento</b>.
                </span>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <Accordion activeIndex={0}>
              {variables &&
                Object.keys(variables?.global).map((title) => (
                  <AccordionTab header={title}>
                    {console.log(title)}
                    <div className="d-flex flex-wrap">
                      {variables?.global[title].map((v) => {
                        return (
                          <div className="p-2 my-1" key={v.id}>
                            <CopyTextInput
                              text={v}
                              onClick={() => {
                                toast.success(`Texto copiado com sucesso`);
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </AccordionTab>
                ))}

              {variables &&
                Object.keys(variables?.[type]).map((title) => (
                  <AccordionTab key={title} header={title}>
                    {console.log(title)}
                    <div className="d-flex flex-wrap">
                      {variables?.[type]?.[title]?.map((v, index) => (
                        <div className="p-2 my-1" key={index}>
                          <CopyTextInput
                            text={v}
                            onClick={() => {
                              toast.success(`Texto copiado com sucesso`);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </AccordionTab>
                ))}
            </Accordion>
          </div>
        </>
      )}
    </Modal>
  );
};

export default Variables;
